import { render, staticRenderFns } from "./AuthGroupProcedure.vue?vue&type=template&id=523c6bb7&"
import script from "./AuthGroupProcedure.vue?vue&type=script&lang=js&"
export * from "./AuthGroupProcedure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports